

























import { editFactory } from '@/main/pages';
import { openList } from '@/main/router/routerPath';
import { apiProvider as followupEmailConfigProvider } from '@/modules/oem/FollowupEmailConfig/api';
import { AUTH_LOGOUT, AUTH_USER, SSO_SIGNOUT } from '@/main/store/actionTypes';
import { mapActions } from 'vuex';


import { NAME } from './constants';
import { store } from './store/edit';

export default editFactory(NAME, store).extend({
	methods: {
		...mapActions({
			clearPages: `pageManager/${'PAGE_MGR_CLEAR'}`,
			logoutUser: AUTH_LOGOUT,
			SSOLogout: SSO_SIGNOUT,
			authUser: AUTH_USER,
		}),
		async saveClick() {
			if (await this.validate()) {
				this.startLoading();
				followupEmailConfigProvider.updateEntity(this.Id);
				this.endLoading();
				this.openFollowupEmailConfigList();
			}
		},
		async openFollowupEmailConfigList(checkFilters = true) {
			openList(NAME, { checkFilters });
		},
	},
});
